export const Routes = {
  homePage: '/',
  loginPage: '/login',
  signUpPage: '/sign-up',
  api: '/html-api',
  projectsPage: '/projects',
  users: '/users',
  editProfile: '/edit-profile',
  editProfileClient: '/edit-profile-client',
  resetPassword: '/reset-password',
  forgotPassword: '/forgotpassword',
  audits: '/audits',
}
